// taken from https://docs.google.com/spreadsheets/d/13WY5UMs8YVFDCQUCYb9iE2PdGXTUN0uwTN9kyRteFlo/edit#gid=1019960066
export const questionValueTypes = [
	"string",
	"decimal",
	"integer",
	"boolean",
	"uuid",
	"date",
	"time",
	"datetime",
	"email",
	"iban",
	"licensePlateNld",
	"postalcodeNld",
	"phoneNumber",
] as const;
export type QuestionValueType = typeof questionValueTypes[number];
